import React, {Component} from 'react'
import {Input, Label, FormGroup, Button, Row, Col, Badge} from 'reactstrap'
import PropTyoes from 'prop-types'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import Search from "./Search";

const {format} = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
});

export default class AddProject extends Component{

    constructor(props){
        super(props)
    }

    state = {
        project: null,
        activity_type_id: null,
        project_activity_budget_id: null,
        detail: null
    }

    setProject = (project) => {
        console.log(project)
        this.setState({project, activity_type_id: null, project_activity_budget_id: null, detail: null})
    }

    setActivity = (project_activity_budget_id, project_activity_type_id) => {
        this.setState({activity_type_id: project_activity_type_id, project_activity_budget_id})
    }

    setDetail = (evt) => {
        const {value} = evt.target
        this.setState({detail: value})
    }

    resetState = () => {
        this.setState({project: null, activity_type_id: null, project_activity_budget_id: null, detail: null})
    }

    onAdd = () => {
        const {project, activity_type_id, project_activity_budget_id, detail} = this.state
        if(this.props.onAdd) this.props.onAdd(
            {
                project_id: project.project_id,
                activity_type_id,
                project_activity_budget_id,
                detail
            })
        this.search.getInstance().clear()
        this.resetState()
    }

    onSearch = (query) => {
        if(query == ''){
            this.resetState()
        }
    }


    render(){
        return (
            <Row>
                <Col>
                    <Search
                        placeholder="Search Projects"
                        onChange={(projects) => this.setProject(projects[0])}
                        onSearch={this.onSearch}
                        reference={ref => this.search = ref}
                    />
                </Col>
                <Col>
                    {(this.state.project && this.state.project.project_activity_budgets) &&
                    this.state.project.project_activity_budgets.map(({
                        id,
                        description,
                        budget_total,
                        budget_used,
                        supplier_total,
                        project_activity_type,
                        project_activity_type_id,
                        address,
                        stage
                    }, index) => {
                        const remainingBudget = (budget_total || 0) - (budget_used || 0) - (supplier_total || 0)
                        return (
                        <FormGroup className="pb-3" check key={index}>
                            <Label check style={{display: 'block'}}>
                                <Input
                                    onChange={() => this.setActivity(id, project_activity_type_id)}
                                    type="radio"
                                    value={project_activity_type_id}
                                    name="activities"
                                />
                                {(stage) && `Stage: ${stage} - `}{project_activity_type.description} {(description) && ` - ${description}`}
                                {(address) && <h6><Badge color="primary">{address.full_address}</Badge></h6>}
                                <p><Badge color={remainingBudget <= 0 ? 'danger' : 'light'}>Remaining Budget: {format(remainingBudget)}</Badge></p>
                            </Label>
                        </FormGroup>)
                        }
                    )}
                </Col>
                <Col>
                    {(this.state.project && this.state.activity_type_id) && <Input
                        size="sm"
                        type="textarea"
                        placeholder="What are you working on?"
                        onChange={this.setDetail}/>}
                </Col>
                <Col>
                    <Button
                        className="float-right"
                        size="sm"
                        color="success"
                        disabled={(!this.state.project || !this.state.activity_type_id)}
                        onClick={this.onAdd}>
                        <FontAwesomeIcon
                            icon="plus"
                        />{' '}
                        Add Project
                    </Button>
                </Col>
            </Row>

        )
    }

}

PropTyoes.propTypes = {
    onAdd: PropTyoes.func
}